import {
  SET_PENDING,
  SET_TOUCHED,
  SET_PORTAL_USERS,
  FORGET_PORTAL_USERS,
} from "./types";

const INITIAL_STATE = {
  all: [],
  ref: {},
  pending: true,
  touched: false,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_PENDING:
      return { ...state, pending: payload };
    case SET_TOUCHED:
      return { ...state, touched: payload };
    case SET_PORTAL_USERS:
      return { ...state, all: payload };
    case FORGET_PORTAL_USERS:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};
